var map = {
	"./11oz-Mug.svg": "0f1d",
	"./15oz-Mug.svg": "14c6",
	"./Special-Mug.svg": "0277",
	"./Steel-Bottle.svg": "2b4b",
	"./Steel-Mug.svg": "bf89",
	"./apron.svg": "0c4f",
	"./blanket.svg": "0ffd",
	"./canvas.svg": "9a0d",
	"./coasters.svg": "26b1",
	"./desk mat.svg": "b285",
	"./dtg-shirt.svg": "01fd",
	"./face mask.svg": "3ee7",
	"./keychain.svg": "9a15",
	"./leggings.svg": "5c56",
	"./lunch bag.svg": "be37",
	"./mouse pad.svg": "1798",
	"./napkin.svg": "0060",
	"./necklace.svg": "d4f9",
	"./ornament.svg": "9477",
	"./oven mitts.svg": "ff12",
	"./pet blanket.svg": "04d3",
	"./pet bowl.svg": "bbb4",
	"./phone-case.svg": "cec4",
	"./pillow-filled.svg": "a341",
	"./pillow.svg": "c5e9",
	"./pouch.svg": "1bbd",
	"./scarf.svg": "6d23",
	"./shirt.svg": "50b3",
	"./skirt.svg": "a6a4",
	"./socks.svg": "6756",
	"./storage box.svg": "8ca3",
	"./table cloth.svg": "5396",
	"./tee.svg": "a689",
	"./tote bag.svg": "525f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";